<template>
  <div id="app" class="wrapper" :class="{ bottomPanel: bottomPanel, ie: isIE }">
    <div id="bg" :class="{'add-blur': false}"/>
    <div id="bg2" v-if="this.$route.path != '/'"/>
    <transition name="page" mode="out-in">
      <router-view @changePadding="changePadding"></router-view>
    </transition>
    <transition name="fade">
      <footer-view v-if="showFooter" />
    </transition>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
  name: 'app',
  data () {
    return {
      bottomPanel: false,
      isIE: navigator.userAgent.indexOf('Trident') !== -1
    }
  },
  computed: {
    showFooter () {
      return this.$route.name === 'RealCards' || this.$route.name === 'VirtualCards' || this.$route.name === 'Index' || this.$route.name === 'Activation'
    }
  },
  components: {
    FooterView: Footer
  },
  methods: {
    changePadding (val) {
      this.bottomPanel = val
    }
  }
}
</script>

<style>
  @import '../node_modules/normalize.css/normalize.css';
  @import 'inputs.css';

  @font-face {
    font-family: Bebas;
    src: url('/static/fonts/Bebas/BebasNeue_Regular.eot?') format('eot'),
         url('/static/fonts/Bebas/BebasNeue_Regular.woff') format('woff'),
         url('/static/fonts/Bebas/BebasNeue_Regular.otf') format('opentype'),
         url('/static/fonts/Bebas/BebasNeue_Regular.ttf') format('truetype');
    font-weight: 400;
  }

  @font-face {
    font-family: Bebas;
    src: url('/static/fonts/Bebas/BebasNeue_Bold.eot?') format('eot'),
         url('/static/fonts/Bebas/BebasNeue_Bold.woff') format('woff'),
         url('/static/fonts/Bebas/BebasNeue_Bold.otf') format('opentype'),
         url('/static/fonts/Bebas/BebasNeue_Bold.ttf') format('truetype');
    font-weight: 700;
  }

  @font-face {
    font-family: Museo;
    src: url('/static/fonts/Museo/MuseoSansCyrl-500.eot?') format('eot'),
         url('/static/fonts/Museo/MuseoSansCyrl-500.woff') format('woff'),
         url('/static/fonts/Museo/MuseoSansCyrl-500.otf') format('opentype');
    font-weight: 500;
  }

  @font-face {
    font-family: Museo;
    src: url('/static/fonts/Museo/MuseoSansCyrl-700.eot?') format('eot'),
         url('/static/fonts/Museo/MuseoSansCyrl-700.woff') format('woff'),
         url('/static/fonts/Museo/MuseoSansCyrl-700.otf') format('opentype');
    font-weight: 700;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
    outline: none;
  }

  html, body {
    width: 100%;
    height: 100%;
  }

  body {
    box-sizing: border-box;
    font-family: Museo;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .page-enter-active {
    transition: opacity 0.3s ease-out, transform 0.25s ease-out;
  }

  .page-leave-active {
    transition: opacity 0.2s ease-in, transform 0.25s ease-in;
  }

  .page-enter {
    transform: translateY(-30px);
    opacity: 0;
  }
  .page-leave-active {
    transform: translateY(30px);
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .content-box-component {
    box-sizing: content-box;
  }
  .visually-hidden {
    position: absolute;
    overflow: hidden;
    clip: rect(0 0 0 0);
    height: 1px;
    width: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
  }
  a {
    color: inherit;
    cursor: pointer;
    text-decoration: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .center {
    text-align: center;
  }

  .btn {
    border: none;
    cursor: pointer;
    padding: 0;
  }

  [disabled] {
    pointer-events: none;
  }

  [hidden] {
    display: none;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    -webkit-user-select: none;
    -webkit-user-modify: read-only;
    margin: 0;
  }

  select {
    -moz-appearance: none;
    -webkit-appearance: none;
  }

  .clearfix::before,
  .clearfix::after {
    content: "";
    display: table;
  }

  .clearfix::after {
    clear: both;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    min-height: 100%;
  }
  .wrapper.bottomPanel {
    padding-bottom: 50px;
  }

  .index,
  .select-type,
  .root {
    background-color: #4f9ab4;
  }

  .root.no-bg {
    background-image: none;
  }

  .root {
    background-size: contain;
  }

  .index,
  .select-type,
  .root.empty,
  .root.modal {
    background-size: contain;
  }

  .index,
  .select-type {
    background-size: auto, cover;
    background-position: center, top;
    background-position-y: 25px, 0;
  }

  .root {
    background-color: #4f9ab4;
  }

  .field {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fafafa;
    border: 1px solid rgba(139, 139, 139, .5);
    border-radius: 0;
    box-shadow: none;
    font-family: inherit;
    height: 45px;
    min-height: 45px;
    padding: 0 15px;
    width: 425px;
    max-width: 100%;
  }
  .phone-field{
    width: 425px;
  }

  span.input.invalid .field,
  span.input.invalid-email .field,
  div.input.invalid .field,
  div.city-select.invalid .field {
    border: 1px solid rgba(255, 0, 0, .5);
  }

  span.input.card-text.invalid::after {
    content: 'Пожалуйста, заполните правильно это поле';
    display: inline-block;
    position: absolute;
    top: 100%;
    padding-top: 4px;
    font-size: 13px;
    font-weight: 100;
    width: 100%;
    color: rgba(255, 0, 0, 0.5);
    text-align: left;
  }

  span.input.invalid::after,
  span.input.invalid-email::after,
  div.input.invalid::after,
  .city-select.invalid::after {
    content: 'Пожалуйста, заполните это поле';
    display: inline-block;
    position: absolute;
    bottom: -16px;
    left: 1px;
    font-size: 13px;
    font-weight: 100;
    width: 250px;
    color: rgba(255, 0, 0, 0.5);
    text-align: left;
  }

  span.input.invalid-email::after {
    content: 'Пожалуйста, введите корректный e-mail адрес';
    width: 100%;
    top: auto;
  }

  span.input.card-amount.invalid::after {
    display: none;
  }

  span.input .amount-error {
    display: none;
    font-size: 13px;
    font-weight: 100;
    color: rgba(255, 0, 0, 0.5);
    position: absolute;
    top: 48px;
    left: 1px;
  }

  span.input.invalid .amount-error {
    display: block;
  }

  .city-select.invalid::after {
    bottom: 19px;
    left: 87px;
  }

  textarea.field {
    height: 88px;
    margin-bottom: -2px;
    padding-top: 12px !important;
    resize: none;
    width: 100%;
  }

  .field[readonly],
  .field[disabled] {
    background: transparent;
  }

  .short.field {
    width: 351px;
    padding-top: 4px;
  }
  .nowrap {
    white-space: nowrap;
  }

  .full-width {
    width: 100%;
  }

  .input .code {
    bottom: 13px;
    color: rgba(0, 0, 0, .5);
    display: none;
    left: 16px;
    position: absolute;
  }

  .input:not(.input--filled) .field:focus ~ .code {
    display: initial;
  }

  .custom-input {
    height: 100%;
    background-color: #fafafa;
    border: none;
    width: calc(100% - 16px);
  }

  .calendar {
    left: -1px;
    top: 43px;
    background: #fafafa !important;
  }

  .calendar .cell.selected,
  .calendar .cell.selected.highlighted,
  .calendar .cell.selected:hover {
    background: #f5bfcc !important;
  }

  .calendar .cell:not(.blank):not(.disabled).day:hover,
  .calendar .cell:not(.blank):not(.disabled).month:hover,
  .calendar .cell:not(.blank):not(.disabled).year:hover {
    border: 1px solid #f5bfcc !important;
  }

  .index,
  .select-type,
  .root {
    background: none;
  }

  #app {
    min-height: 100vh;
  }

  #bg {
    z-index: -2;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-size: cover;
    background-position: top center;
    background-image: url('/static/img/bg/bg_desktop.jpg');
    background-attachment: fixed;
  }
  .add-blur {
    filter: blur(10px);
  }

  /*#bg2 {*/
  /*  z-index: -1;*/
  /*  filter: blur(1px);*/
  /*  position: fixed;*/
  /*  top: 0;*/
  /*  left: 0;*/
  /*  height: 100%;*/
  /*  width: 100%;*/
  /*  background-size: cover;*/
  /*  background-position: top center;*/
  /*  background-color: #E3E3E3;*/
  /*  opacity: 0.4;*/
  /*  background-attachment: fixed;*/
  /*}*/
  @media screen and (min-width: 1023px) {
    #bg2 {
      z-index: -1;
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-size: cover;
      background-position: top center;
      background-image: url('/static/img/bg/bg_desktop2.jpg');
      background-attachment: fixed;
    }
  }

  /* .container {
    height: 100%;
    width:1024px;
    padding: 0 2px;
    margin: 0 auto;
  } */
  @media screen and (max-width: 1536px) {
    #bg2 {
      background-image: url('/static/img/bg/bg_hd2.jpg');
    }
  }
  /*=============================================>>>>>
  = Mobile =
  ===============================================>>>>>*/
  @media screen and (max-width: 1023px) {
    #bg {
      background-image: url('/static/img/bg/bg_tablet2.jpg');
    }
    .field, .phone-field {
      width: 100%;
    }
    .add-blur {
      filter: none;
    }

    .city-select.invalid::after {
      left: 20px;
    }
  }

  @media screen and (max-width: 320px) {
    .city-select.invalid::after {
      left: 10px;
    }
  }

  @media screen and (max-width: 767px) {
    #bg {
      background-image: url('/static/img/bg/bg_mobile2.jpg');
    }
  }
</style>
